import styled from 'styled-components';
import { ChevronIcon } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons';
import { ServiceChat } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/pictures';

const ChatContainerStyled = styled.div`
  cursor: default;
  display: flex;
  padding: 16px 32px;
  justify-content: center;
  align-items: center;
  gap: 16px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 2px 4px 0px rgba(14, 20, 29, 0.15);
  margin-top: 24px;
  cursor: pointer;
`;

const InfoStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;

  & > h1 {
    color: #0e141d;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
  }

  & > h2 {
    color: #494c66;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
`;

const ContainerIconStyled = styled.div`
  width: 44px;
  height: 40px;
`;
const ChatIconStyled = styled(ServiceChat)`
  transform: scale(0.5);
  margin-top: -20px;
  margin-left: -20px;
  path {
    fill: #4d008c;
  }
`;

const ChevronStyled = styled(ChevronIcon)`
  transform: rotate(-90deg);
  path {
    fill: #e92070;
  }
`;

export {
  ChatContainerStyled,
  InfoStyled,
  ChevronStyled,
  ChatIconStyled,
  ContainerIconStyled,
};
